enum IMAGE_TYPE {
    SVG,
    CUSTOM,
}
interface IIconInfo {
    iconType: IMAGE_TYPE;
    iconName: string;
    activeIconName?: string;
    normalIcon: string;
    activeIcon: string;
    svgUrl?: string;
    activeSvgUrl?: string;
    color: string;
    normalColor?: string;
}
export {
    IMAGE_TYPE,
    IIconInfo,
}
